"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _theming = _interopRequireWildcard(require("../../utils/theming"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding-top: 0px;\n  padding-bottom: 0px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  backgroundColor: transparent;\n  vertical-align: middle;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = {
  getBaseStyle: function getBaseStyle(props) {
    var theme = props.theme,
        color = props.color,
        fontColor = props.fontColor,
        inverse = props.inverse,
        size = props.size,
        disabled = props.disabled,
        minimal = props.minimal;
    var componentStyles = theme.components.button;
    var primary = inverse || minimal ? fontColor : color;
    var secondary = inverse || minimal ? color : fontColor;
    var options = {
      primary: theme.palette[primary],
      secondary: theme.palette[secondary],
      inverse: inverse,
      minimal: minimal,
      disabled: disabled
    };
    var defaultStyles = componentStyles.defaults(options);
    var sizeStyles = componentStyles.sizes[size];
    var disabledStyles = disabled ? componentStyles.disabled(options) : {};
    var inverseStyles = inverse ? componentStyles.inverse(options) : {};
    var linkStyled = minimal ? componentStyles.minimal(options) : {};
    return Object.assign({}, defaultStyles, {}, sizeStyles, {}, inverseStyles, {}, linkStyled, {}, disabledStyles);
  },
  getBlockStyle: function getBlockStyle(_ref) {
    var fullWidth = _ref.fullWidth;
    return fullWidth ? (0, _theming.css)({
      width: '100%'
    }) : {};
  },
  getCircleButtonStyle: function getCircleButtonStyle(_ref2) {
    var theme = _ref2.theme,
        shape = _ref2.shape,
        size = _ref2.size,
        minimal = _ref2.minimal,
        disabled = _ref2.disabled;
    var minimalStyles = minimal && !disabled && theme.components.button.circle.minimal ? Object.assign({}, theme.components.button.circle.minimal.enabled) : {};

    if (shape === 'circle') {
      return Object.assign({
        paddingLeft: 0,
        paddingRight: 0,
        height: theme.components.button.circle[size],
        width: theme.components.button.circle[size]
      }, minimalStyles);
    }

    return null;
  }
};
var SyntheticButton = (0, _theming.default)('div')(_templateObject(), style.getBaseStyle, style.getBlockStyle, style.getCircleButtonStyle);
SyntheticButton.defaultProps = {
  color: 'ctaPrimary',
  fontColor: 'light',
  size: 'medium',
  fullWidth: false
};
var _default = SyntheticButton;
exports.default = _default;